module.exports = {
  // ######################
  // Required Section Start
  // ######################

  // Main page title
  title: "개발자 이동령",

  // Main page description (callout)
  description:
    "안녕하세요, Web Front-end 개발자 지망생 이동령(LellowMellow) 입니다. 해당 블로그는 Front-end 와 관련해 학습한 결과와 경험들을 모아놓은 공간입니다.",

  // Meta tage description
  metaDescription: "Festina lente, Make haste slowly",

  // Blog name
  blogName: "LellowMellow.dev",

  // Post author name
  author: "LellowMellow",

  // Blog site url
  siteUrl: "https://lellowmellow.github.io",

  // Icons
  // Enter the desired Icon name in the field below the link.
  // Example: main: "TbAlien"
  // https://react-icons.github.io/react-icons/icons/tb/
  // main: Main page icon
  // profile: Navigation bar author icon
  mainIcon: "TbTopologyStarRing3",

  // ######################
  // Required Section End
  // ######################

  // ######################
  // Optional Section Start
  // ######################

  // Navigation bar bio links
  // Do not remove keys, only modify the links.
  // Use an empty string if a link is not available.
  links: {
    github: "https://github.com/LellowMellow",
    linkedin: "",
    youtube: "",
    x: "",
    threads: "",
    instagram: "https://www.instagram.com/lell0w_mell0w/",
    gmail: "mailto:dr11291129@gmail.com",
  },

  // Navigation bar additional bio links
  // Feel free to add new keys if necessary.
  // If not using a key, leave it as an empty object.
  // Example: { icon: "TbBrandTiktok", title: "Tiktok", url: "https://www.tiktok.com/" }
  additionalLinks: [],

  // ######################
  // Optional Section End
  // ######################
}
